import { compose, createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import _merge from 'lodash/merge';

import { staticReducers } from 'client/redux/staticReducer';
import { getGameReducer, initGameReducer, initMgmSelfReducer } from 'client/redux/gameReducer';

const INIT_PROMO = 'store/init_promo';
export function initAppState(initData) {
    return {
        type: INIT_PROMO,
        payload: {
            initData
        }
    };
}

function createReducer(asyncReducers = {}) {
    const reducers = combineReducers({ ...staticReducers, ...asyncReducers });
    return (state, action) => {
        if (action.type === INIT_PROMO) {
            state = _merge({}, state, action.payload.initData);
        }
        return reducers(state, action);
    };
}

function configureStore() {
    const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(createReducer(), composeEnhancer(applyMiddleware(thunk)));

    store.injectGameReducer = (...args) => {
        return store.replaceReducer(createReducer(getGameReducer(...args)));
    };
    store.initGameReducer = gameType =>
        initGameReducer(gameType, (...args) => store.dispatch(...args));

    store.initMgmSelfReducer = isMgmSelf =>
        initMgmSelfReducer((...args) => store.dispatch(...args), isMgmSelf);

    return store;
}

export default configureStore();
